import { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { addToHistory } from '../../utils/navigation'

/**
 * Componente para rastrear o histórico de navegação
 * Esse componente não renderiza nada, apenas monitora as mudanças de rota
 * e armazena o histórico na sessionStorage usando a função utilitária
 */
const NavigationHistoryTracker = ({ location }) => {
  useEffect(() => {
    // Ignorar mudanças que incluem hash na URL (ex: #section1)
    if (location.hash) {
      return
    }

    // Adicionar o caminho atual ao histórico de navegação
    const currentPath = location.pathname + location.search
    addToHistory(currentPath)
  }, [location])

  // Não renderiza nada, apenas rastreia a navegação
  return null
}

export default withRouter(NavigationHistoryTracker)
